module.exports = __webpack_public_path__ + "img/1723011773647-WhatsApp Image 2024-08-07 at 12.02.11.jpeg.3ed6c565.webp";